import { isJasmineRunning } from './testEnv';
export const isHubSpotOrigin = origin => {
  // Allow Jasmine tests to run for CSAT message
  if (isJasmineRunning() && origin === window.location.origin) return true;
  const regex = /hubspot(?:qa)?\.com/;
  return regex.test(origin);
};